module.exports = __webpack_public_path__ + "static/media/document.390526c9.png";